import { createFileRoute } from '@tanstack/react-router'
import MealsConfigurationPage from '@/features/meals/meals-configuration-page'

export const Route = createFileRoute('/_authenticated/dashboard/meals/configuration')({
  component: MealsConfigurationPage,
})
